// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1976c689","239":"138e0591","455":"951c1aaa"}[chunkId] + ".chunk.js";
};